<ng-container>
    <p-confirmDialog #cd [style]="{width: '{{dialog.size}}vw'}" key="dialog" [closable]="false">
        <ng-template pTemplate="header">
            <!-- <div class="mt-2"></div> -->
        </ng-template>
        <ng-template pTemplate="footer">
            <p-button *ngFor="let opt of dialog.options; let last = last" styleClass="{{opt.class}} marginbuttom" type="button"
                [icon]="opt.icon" [label]="opt.title" (click)="opt.type == optionType.Negative? cd.reject(): cd.accept()"></p-button>
        </ng-template>
    </p-confirmDialog>
</ng-container>
